export const preventMinus = (event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
  if (event.code === 'Minus') {
    event.preventDefault();
  }
};

export const preventDotAndComma = (event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
  if (event.key === '.' || event.key === ',') {
    event.preventDefault();
  }
};

export const isValidSlug = (slug: string): boolean => {
  const slugPattern = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
  return slugPattern.test(slug);
};
